import { cx } from "@emotion/css";
import dayjs from "dayjs";
import LogoIcon from "img/logo.svg";
import { useTranslation } from "react-i18next";
import { Avatar } from "src/components/Default/Avatar";
import { CommentActions } from "src/components/NewComponents/Exam/OptionDetails/Comments/CommentActions";
import { useSlot } from "src/components/Slots/SlotsContext";
import { isLek } from "src/helpers/services";
import { useFontSize } from "src/hooks/useFontSize";
import logoCem from "src/images/static/logoCem.png";
import { Tooltip } from "../../../../Default/LekUI/Tooltip";
import Hint from "../../../Default/Hint";

const CemLogo = () => {
	if (!isLek()) {
		return null;
	}

	return (
		<div className="cem_comment">
			<img src={logoCem} alt="logoCem" className="cem_comment--image" />
			<Hint
				className="cem_comment--hint"
				hint="Komentarz został dodany przez użytkownika do bazy pytań na stronie cem.edu.pl"
			/>
		</div>
	);
};

export const CommentInfo = ({
	comment,
	isReply,
	setIsReply,
	allowReply,
	onRemoveComment,
	onToggleLike,
}) => {
	const { fontSizeNormalClass, getFontSizeClass } = useFontSize();
	const { t } = useTranslation();
	const ActionsSlot = useSlot("commentActions");

	const renderAdminInfo = () => {
		if (!comment.user.isStaff) {
			return null;
		}

		return (
			<Tooltip title={t("tooltips.admin")}>
				<div className="admin-comment">
					<LogoIcon />
					<span className={getFontSizeClass(-2)}>{t("exam.moderator")}</span>
				</div>
			</Tooltip>
		);
	};

	const renderCemInfo = () => {
		if (comment.type !== "CEM" || !isLek()) {
			return null;
		}

		return <CemLogo />;
	};

	const renderUserName = () => {
		if (!comment.type || comment.type !== "CEM") {
			return (
				<span className={cx(fontSizeNormalClass, "font-bold text-black")}>
					{comment.user.username}
				</span>
			);
		}

		if (comment.type === "CEM") {
			return <span>Komentarz</span>;
		}

		return null;
	};

	return (
		<div className="flex items-center justify-between">
			<div className="flex-1 ofx-hidden flex items-center justify-start gap-8">
				<Avatar
					avatarUrl={comment.user.avatarUrl}
					avatarClassName="avatar-24"
				/>
				{renderUserName()}
				{renderAdminInfo()}
				{renderCemInfo()}
			</div>
			<div className="flex items-center justify-end">
				<span className="size-12-light text-grey">
					{dayjs(new Date(comment.date)).format("DD-MM-YYYY")}
				</span>
				{ActionsSlot && <ActionsSlot comment={comment} />}
				<CommentActions
					onRemoveComment={onRemoveComment}
					comment={comment}
					isReply={isReply}
					setIsReply={setIsReply}
					allowReply={allowReply}
					onToggleLike={onToggleLike}
				/>
			</div>
		</div>
	);
};
